import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import('../views/home/index')
  },
  // 介绍
  {
    path: "/introduce",
    name: "introduce",
    component: () => import('../views/introduce/introduce')
  },
  // 银行合作
  {
    path: "/cooperation",
    name: "cooperation",
    component: () => import('../views/cooperation/cooperation')
  },
  // 企业授信
  {
    path: "/enterprise",
    name: "enterprise",
    component: () => import('../views/enterprise/enterprise')
  },
  // 加盟
  {
    path: "/join",
    name: "join",
    component: () => import('../views/join/join')
  },
  // 新闻
  {
    path: "/news",
    name: "news",
    component: () => import('../views/news/news')
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import('../views/news/newsDetail')
  },
  // 联系我们
  {
    path: "/contact",
    name: "contact",
    component: () => import('../views/contact/contact')
  },
  //登录
  {
    path: "/login",
    name: "login",
    component: () => import('../views/user/login')
  },
  //授信进度
  {
    path: "/creditProgress",
    name: "creditProgress",
    component: () => import('../views/my/creditProgress')
  },
  //代理审核进度
  {
    path: "/reviewProgress",
    name: "reviewProgress",
    component: () => import('../views/my/reviewProgress')
  },
  //我的企业
  {
    path: "/myCompany",
    name: "myCompany",
    component: () => import('../views/my/myCompany')
  },
  //编辑企业
  {
    path: "/editCompany",
    name: "editCompany",
    component: () => import('../views/my/editCompany')
  },
  //产品列表
  {
    path: "/productList",
    name: "productList",
    component: () => import('../views/my/productList')
  },
  //产品详情
  {
    path: "/productDetail",
    name: "productDetail",
    component: () => import('../views/my/productDetail')
  },
  //产品申请
  {
    path: "/productApply",
    name: "productApply",
    component: () => import('../views/my/productApply')
  },
  //代理加盟申请
  {
    path: "/agentApply",
    name: "agentApply",
    component: () => import('../views/agent/agentApply')
  },
  //代理加盟申请第二步
  {
    path: "/agentApplySecond",
    name: "agentApplySecond",
    component: () => import('../views/agent/agentApplySecond')
  },
  //代理加盟申请第三步
  {
    path: "/agentApplyThird",
    name: "agentApplyThird",
    component: () => import('../views/agent/agentApplyThird')
  },

  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import('../views/test')
  // },
];

const router = new VueRouter({
  routes,
  mode:'history',
  scrollBehavior: () => ({
    y: 0
  }),
});

export default router;
